<img src="{{sourceLogo}}" style="width: 100px;height: 100px;display: block;margin-left: auto;margin-right: auto;">
<div *ngIf="isError==0">
    <h3 style="text-align: center;font-family: Arial, Helvetica, sans-serif;">Please wait, opening payment gateway.</h3>
    <form #form ngNoForm id="nonseamless" method="post" name="redirect" action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction">
        <!-- <input type="hidden" id="encRequest" name="encRequest" value="{{ encRequest }}" />
        <input type="hidden" name="access_code" id="access_code" value="{{ accessCode }}" />
        <input type="hidden" name="source" id="source" value="{{ source }}" /> -->
        <input type="hidden" id="encRequest" name="encRequest" [value]="encRequest" />
        <input type="hidden" name="access_code" id="access_code" [value]="accessCode" />
        <input type="hidden" name="source" id="source" [value]="source" />      
    </form>
</div>
<div *ngIf="isError==1">
    <h1 style="text-align: center;">Time Out!!!</h1>
</div>
<div *ngIf="isError==2">
    <h1 style="text-align: center;">Something Wrong</h1>
</div>